<template>
  <div class="video universal">
    <h1 class="page-title">极客时间 · {{data_content.total || 0}}</h1>
    <div class="geek-tab-list">
      <ul>
        <li
          v-for="(tabItem) in tabList"
          :key="tabItem.key"
          :class="{'is-active': activeTab.tabId==tabItem.tabId}"
          @click="changeTab(tabItem)"
        >{{ tabItem.label }}</li>
      </ul>
    </div>
    <div v-if="hasContent">
      <GeekTimeCourseItem
        v-for="(item,index) in data_content.records"
        :key="item.id"
        :dateObject="item"
        :tab="activeTab"
        :index="(index + 1 + (pageInfo.current - 1) * pageInfo.pageSize)"
      />
    </div>
    <None v-else />

    <DevPagination
      class="margin-top-66"
      :total="data_content.total"
      :pageSize="10"
      :change="change"
      @currentChange="postDate"
    />
  </div>
</template>

<script>
import DevPagination from "@/components/Base/DevPagination.vue";
import GeekTimeCourseItem from "@/components/Course/GeekTimeCourseItem.vue";
import None from "@/components/Base/None.vue";
import {
  getSubscribeCourseList,
  getGeekTimeData,
} from "@/utils/api";

const tabList = [
  { label: '领域会员卡', key: 'vipCard', tabId: 0},
  { label: '视频课程', key: 'video', tabId: 1},
  { label: '专栏课程', key: 'complex', tabId: 2},
  { label: '学习记录', key: 'studyRecord', tabId: 3},
]
export default {
  name: 'GeekTime',
  components: {
    DevPagination,
    GeekTimeCourseItem,
    None,
  },
  data() {
    return {
      // 注：第一页数据的请求由DevPagination组件触发
      data_content: {
        records: [],
      },
      tabList,
      activeTab: tabList[0],
      pageShow: false,
      change: false,
      size: 0,
      pageInfo: {},
    };
  },
  computed: {
    hasContent() {
      return this.data_content?.records?.length > 0
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化函数
    init() {
      this.data_content = {
        records: [],
      };
    },
    postDate(page) {
      this.pageInfo = page;

      this.$store.dispatch("changeLoading", true);
      this.getGeekTimeData()
    },
    changeTab(targetTab) {
      this.activeTab = targetTab;
    },
    // 根据类型获取极客时间下数据，类型枚举：'领域会员卡','视频课程','专栏课程','学习记录'
    getGeekTimeData() {
      const reqParams = {
        type: this.activeTab.key,
        pageNum: this.pageInfo.current,
        pageSize: this.pageInfo.pageSize,
      }
      getGeekTimeData(reqParams).then((response) => {
        this.data_content = response.data;
      }).catch(err => {
        
      }).finally(() => {
        this.$store.dispatch("changeLoading", false);
      });
    },
  },
  watch: {
    'activeTab.tabId': {
      handler() {
        this.change = !this.change;
        this.init();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.geek-tab-list {
  margin-bottom: 16px;
  width: 100%;
  display: flex;
  align-items: center;

  ul {
    display: flex;
    align-items: center;
    list-style: none;

    li {
      margin-right: 24px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 16px;
      user-select: none;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }

    .is-active {
      color: #222226;
    }

    .title {
      cursor: default;
    }
  }
}

.video {
  .margin-top-66 {
    margin-top: 66px;
  }
}
</style>
